module.exports = __webpack_public_path__ + "static/img/7291_phase_function_Paper_Points.cef8e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7291_phase_function_Paper_Points.png
// module id = klyo
// module chunks = 0